import { importantTagLevels } from '../../constants-v2'
import TagMappings from '../../../shared/TagMappings.json'

export const mapTagsToFlags = (invoice) => {
  const { tags } = invoice
  const flags = tags
    .filter((tag) => {
      return importantTagLevels.includes(tag.level)
    })
    .map((tag) => {
      const foundMapping = TagMappings[tag.key]
      if (!foundMapping) {
        return String(tag.key).replace('_', ' ')
      }
      return foundMapping[0]
    })
  if (invoice.verificationStatus === 'in_progress') {
    flags.push(TagMappings['WAITING_FOR_BROKER_VERIFICATION'][0])
  }
  return flags.join(', ')
}
